import bootstrapMatchTemplate from './template/bootstrap-match.tpl.html';

export default function run($templateCache) {
    $templateCache.put(
        "bootstrap/match.tpl.html",
        bootstrapMatchTemplate,
    );
}

run.$inject = ['$templateCache'];
